module.exports = {
    "message.views.publishTemplateView.addTemplate": "Tambah Template",
    "message.aegInboundDetail.title.cancelReason": "Alasan pembatalan",
    "message.views.inventoryReconciliation.stockChange": "Pergerakan stok",
    "message.aegInboundDetail.purchaseItemColumn.quantityDec": "Jumlah pembelian",
    "message.menu.authorization.auth": "Auth",
    "message.taskCenterView.table.creator": "Pencipta",
    "message.views.workbench.merchantCode": "Pedagang itu",
    "message.views.scItemView.searchButton": "Pencarian",
    "message.transform.InventoryBinding": "Penjilidan persediaan",
    "message.views.workbench.channelItemSold": "Item saluran Terjual",
    "message.taskCenterView.button.search": "Pencarian",
    "message.views.scItemView.width": "Ukuran lebar",
    "message.table.fulfillment.receiverCountry": "Negara penerima",
    "message.outboundView.button.exportAllOrder": "Ekspor semua pesanan",
    "message.outboundView.table.merchantCode": "Kode penjual",
    "message.transform.authStore": "Toko resmi",
    "message.menu.fulfillmentPackage": "Paket pemenuhan",
    "message.lzdInboundDetail.title.estimateTime": "Perkiraan waktu",
    "message.card.fulfillment.receiverCountry": "Negara penerima",
    "message.aegOutboundOrderDetail.title.creator": "Pencipta",
    "message.aegInboundDetail.purchaseItemColumn.sentQty": "Jumlah yang dikirim.",
    "message.transform.isSuccess": "Adalah sukses",
    "message.lzdInboundPlanView.replenishColumns.replQuantity": "Kuantitas Repl",
    "message.views.stockAllocation.outChannel": "Saluran keluar",
    "message.views.productView.merchant": "Pedagang itu",
    "message.lzdInboundDetail.title.warehouseAddress": "Alamat gudang",
    "message.transform.startBind": "Mulai cek ikat toko",
    "message.views.dashboardScore.dashboardName.to_inbound": "Untuk masuk",
    "message.views.workbench.orderQuantity": "Kuantitas pesanan",
    "message.views.workbench.dashboardDescription.totalProductSoldQuantity": "Total produk yang dijual: jumlah total barang di semua gudang mengeluarkan pesanan. Konten dasbor: data volume penjualan produk dalam tujuh hari terakhir. Produk harian yang dijual: jumlah total barang di semua gudang yang mengeluarkan pesanan hari ini",
    "message.table.fulfillment.orderItemStatusDesc": "Status barang pesanan",
    "message.views.activityInventory.activeTime": "Waktu Aktif",
    "message.table.fulfillment.shippingType": "Kode jenis pengiriman",
    "message.aegInboundDetail.title.expiredTime": "Waktu kedaluwarsa",
    "message.aegOutboundOrderDetail.title.outboundTime": "Waktu keluar",
    "message.views.productPublishView.import": "Impor",
    "message.aegOutboundOrderDetail.title.basicInformation": "Informasi dasar",
    "message.views.productPublishView.inputSearchText": "Masukkan teks pencarian",
    "message.views.workbench.productSoldRank": "Peringkat produk yang dijual",
    "message.views.workbench.operation": "Operasi:",
    "message.lzdInboundDetail.lzdItemTable.scItemCode": "Kode Barang",
    "message.table.fulfillment.receiverAddress": "Alamat penerima",
    "message.views.productPublishView.pleaseChooseTheShop": "Silakan pilih toko",
    "message.CreateTransferOrder.receiverName": "Nama penerima",
    "message.button.printPdf": "Cetak Pdf",
    "message.select.fulfillment.deliveryFailed": "Pengiriman gagal",
    "message.views.liveInventory.sellable": "Laku keras",
    "message.views.productPublishView.brand": "MEREK DAGANG",
    "message.menu.productPublishView": "Produk mempublikasikan",
    "message.views.productView.skuStock": "Stok SKU",
    "message.aegInboundDetail.goodsTable.barcode": "Kode batang",
    "message.transform.shopBindException": "Pengecualian pengikatan toko",
    "message.form.fulfillment.inputTrackingNumber": "Masukkan nomor pelacakan!",
    "message.views.productView.searchButton": "Pencarian",
    "message.card.fulfillment.warehouseName": "Nama gudang",
    "message.views.feedback.feedbackType": "Tipe masalah",
    "message.aegInboundDetail.logisticColumns.operator": "操作人",
    "message.views.workbench.authorizationShop": "Toko resmi",
    "message.CreateTransferOrder.senderCountry": "Negara pengirim",
    "message.form.fulfillment.plName": "Penyedia pengiriman",
    "message.views.workbench.totalOrderQuantity": "Jumlah Total pesanan",
    "message.outboundView.table.creator": "Pencipta",
    "message.views.inventoryLedger.inventoryTypeMap.good": "Bagus sekali",
    "message.views.stockAllocation.inChannel": "Di Saluran",
    "message.aegInboundDetail.title.skus": "SKU",
    "message.aegInboundDetail.title.basicInformation": "Informasi dasar",
    "message.lzdInboundCreateView.tableColumn.contactInfo": "Hubungi kami",
    "message.outboundView.table.inventoryType": "Jenis persediaan",
    "message.views.scItemView.reload": "Hapus pilihan",
    "message.views.activityInventory.platformSkuName": "Nama Sku Platform",
    "message.views.productPublishView.plsSelectTheCategory": "Pilih kategori Ya",
    "message.transform.shopBinding": "Jilid toko",
    "message.views.workbench.wow": "Rasio Mingguan",
    "message.lzdOutboundViewDetail.title.sellerAddress": "Alamat penjual",
    "message.taskCenterView.button.reset": "Atur ulang",
    "message.aegOutboundOrderDetail.purchaseItemColumn.title": "Judul",
    "message.outboundView.table.receivedQuantity": "Jumlah yang diterima",
    "message.transform.bindFailedAndDownload": "Pengikatan inventaris gagal, detail kegagalan unduhan",
    "message.views.productView.status": "Status barang",
    "message.views.workbench.dailyProductSold": "Produk harian dijual",
    "message.lzdInboundDetail.lzdItemTable.itemCompleted": "Item selesai",
    "message.views.scItemView.shop": "Toko",
    "message.inboundView.button.LzdTemplate": "Lazada kak",
    "message.inboundView.title.warehouseList": "Gudang masuk",
    "message.common.fulfillment.deliveryConfirm": "Konfirmasi pengiriman",
    "message.views.stockAllocation.allMoreThan100": "Semua rasio tidak diperbolehkan lebih dari 100, silakan sesuaikan.",
    "message.taskCenterView.table.downLoad": "Unduh",
    "message.lzdInboundDetail.lzdItemTable.orderItemStatus": "Status Item",
    "message.table.fulfillment.receiverProvince": "Provinsi penerima",
    "message.aegOutboundOrderDetail.title.logisticOrderCode": "Kode pesanan logistik",
    "message.aegOutboundOrderDetail.logisticColumns.operator": "Operator",
    "message.views.productPublishView.plsSelectThePublishShop": "Pilih toko publikasi",
    "message.outboundView.title.platform": "Hak tebal",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatus": "Memenuhi Status",
    "message.aegOutboundOrderDetail.purchaseItemColumn.returnQtyDec": "Kuantitas pengembalian",
    "message.views.scItemView.scItemMerchant": "Tanda terima pedagang",
    "message.table.fulfillment.actualItemPaidFee": "Biaya dibayar barang sebenarnya",
    "message.views.inventoryAging.150-180day": "150-180 hari",
    "message.transform.bind": "Mengikat",
    "message.views.scItemView.fulfillmentSkuDetail": "Detail pendaftaran SKU",
    "message.views.productView.brand": "MEREK DAGANG",
    "message.views.stockAllocation.cancel": "Batalkan pesanan",
    "message.outboundView.table.operate": "Mengoperasikan",
    "message.table.fulfillment.siteId": "Id situs",
    "message.transform.shopList": "Daftar toko terikat",
    "message.menu.cbFulfillmentOrder": "Pesanan lintas batas",
    "message.aegInboundDetail.title.actualArrivalTime": "Waktu kedatangan aktual",
    "message.aegInboundDetail.logisticColumn.bizOrderNo": "Nomor Pesanan Biz",
    "message.select.fulfillment.partialShipping": "Pengiriman sebagian",
    "message.inboundView.table.orderStatus": "Status barang",
    "message.drawer.fulfillment.deliverySuccess": "Pengiriman berhasil",
    "message.views.publishTemplateView.operation": "Operasi:",
    "message.CreateTransferOrder.destEntityCode": "Gudang paling keren",
    "message.form.fulfillment.reverseTradeOrderId": "Id pesanan terbalik",
    "message.views.scItemView.brand": "MEREK DAGANG",
    "message.views.workbench.suggestToReplenish": "Sarankan untuk mengisi",
    "message.inboundView.alert.sure": "Konfirmasikan",
    "message.taskCenterView.table.taskName": "Nama tugas",
    "message.CreateTransferOrder.receiverAddress": "Alamat penerima",
    "message.card.fulfillment.buyerId": "Id pembeli",
    "message.outboundView.title.orderStatus": "Status pesanan",
    "message.transform.bindCheckSuccess": "Cek pengikatan persediaan berhasil",
    "message.table.fulfillment.orderStatusDesc": "Status pesanan",
    "message.outboundView.button.template": "Templat pakaian",
    "message.views.dashboardScore.dashboardName.effect_of_operation_activity": "Efek aktivitas operasi",
    "message.lzdInboundCreateView.addSkuView.resetBtn": "Atur ulang",
    "message.views.stockAllocation.fulfillmentSkuCode": "Kode Sku pemenuhan",
    "message.table.fulfillment.scItemId": "Id Item Sc",
    "message.form.fulfillment.siteList": "Situs Web",
    "message.lzdInboundDetail.lzdItemTable.goodsBarcode": "Barcode yang bagus",
    "message.transform.ae.description": "Pintu masuk ikat toko AE",
    "message.form.fulfillment.orderStatus": "Status pesanan",
    "message.menu.inOutBound": "Masuk dan keluar",
    "message.views.publishTemplateView.operator": "Operator",
    "message.lzdInboundCreateView.title.sellerAddress": "Alamat penjual",
    "message.views.workbench.today": "Hari ini",
    "message.views.productView.sellerSku": "SKU penjual",
    "message.views.workbench.dashboardDescription.inventoryTurnOver": "Omset persediaan: volume penjualan/persediaan rata-rata dalam bulan terakhir",
    "message.views.scItemView.showRelation": "Menunjukkan hubungan",
    "message.card.fulfillment.receiverCity": "Penerima Kota",
    "message.aegOutboundOrderDetail.logisticColumns.fulfillStatusDesc": "Memenuhi Status Desc",
    "message.views.inventoryReconciliation.changeTypeMap.totalReturnToSeller": "Penjual melebihi batas",
    "message.views.activityInventory.occupyQuantity": "Menempati kuantitas",
    "message.views.productPublishView.category": "Kategori",
    "message.lzdInboundCreateView.tableColumn.submitBtn": "Kirim",
    "message.views.workbench.gmvRank": "Peringkat GMV",
    "message.views.dashboardScore.table.dashboardName": "Nama dasbor",
    "message.lzdOutboundViewDetail.title.inLbxOrderCode": "Pemenuhan pesanan No.",
    "message.views.productPublishView.batchPublish": "Menerbitkan Batch",
    "message.common.fulfillment.ship": "Kapal selam",
    "message.card.fulfillment.receiverAddress": "Alamat penerima",
    "message.card.fulfillment.receiverInfomation": "Informasi penerima",
    "message.aegOutboundOrderDetail.title.skus": "Sku",
    "message.views.scItemView.platformTitle": "Judul PlatformSku",
    "message.transform.startShopBind": "Penjilidan mulai toko",
    "message.views.workbench.productSoldTendency": "Kecenderungan produk Terjual",
    "message.transform.secondStep": "Langkah kedua",
    "message.inboundView.table.orderQuantity": "Kuantitas pesanan",
    "message.inboundView.title.orderStatus": "Status barang",
    "message.views.stockAllocation.submit": "Kirim",
    "message.menu.shipConfirm": "Konfirmasi kapal",
    "message.table.fulfillment.totalItemFee": "Total biaya barang",
    "message.card.fulfillment.itemInfomation": "Informasi barang",
    "message.menu.inboundPlanItem": "Pengisian ulang",
    "message.views.workbench.skuNum": "Sku Nums",
    "message.views.workbench.toDeliver": "Untuk mengantarkan",
    "message.transform.upStep": "Sebelumnya",
    "message.views.inventoryReconciliation.changeTypeMap.totalFound": "Ditemukan",
    "message.inboundView.alert.selectFile": "Berkas yang dipilih",
    "message.transform.record": "Rekaman terikat terbaru",
    "message.views.publishTemplateView.templateDetail": "Templat Detail",
    "message.inboundView.table.merchantCode": "Kode penjual",
    "message.views.inventoryReconciliation.dateRange": "Rentang Tanggal",
    "message.table.fulfillment.quantity": "Kuantitas",
    "message.aegOutboundOrderDetail.consignColumn.purchaseOrderNo": "No keluar.",
    "message.menu.workbench": "Meja kerja",
    "message.views.workbench.activityResult": "Hasil aktivitas",
    "message.table.fulfillment.orderType": "Jenis pesanan",
    "message.views.scItemView.manufacturePackageDimensions": "Dimensi Kemasan pembuatan",
    "message.table.fulfillment.fulfillmentOrderId": "Penggenapan Id pesanan",
    "message.views.liveInventory.warehouseName": "Nama gudang",
    "message.views.liveInventory.seller": "Penjual",
    "message.views.feedback.feedbackContent": "FeedbackContent",
    "message.views.scItemView.logisticsAttributes": "Atribut logistik",
    "message.table.fulfillment.skuId": "Sku Id",
    "message.views.inventoryAging.skuVolumn": "SKU Volumn",
    "message.views.stockAllocation.scItemId": "ScItemId",
    "message.views.inventoryAging.1-30day": "1-30 hari",
    "message.CreateTransferOrder.estimatedInboundTime": "Perkiraan waktu masuk",
    "message.views.scItemView.sellerSku": "Sku penjual",
    "message.inboundView.title.shopName": "Toko",
    "message.views.inventoryAging.fulfillmentSkuCode": "Kode Sku pemenuhan",
    "message.lzdOutboundViewDetail.title.warehouseName": "Gudang gudang",
    "message.common.reset": "Atur ulang",
    "message.views.stockAllocation.adjustRuleFailed": "Gagal menyesuaikan aturan",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherInboundedStock": "Dibatasi lainnya",
    "message.aegInboundDetail.purchaseItemColumn.receivedNormalQty": "Jumlah Normal diterima",
    "message.lzdInboundDetail.title.mobile": "Ponsel seluler",
    "message.views.workbench.orderTime": "Waktu pemesanan",
    "message.aegOutboundOrderDetail.title.supplierId": "Id pemasok",
    "message.views.stockAllocation.platformSkuCode": "Kode Sku Platform",
    "message.login.task_center": "Pusat tugas",
    "message.views.scItemView.addRelatedPlatformSku": "Berkaitan PlatformSku",
    "message.transform.check": "Pemeriksaan penjilidan inventaris",
    "message.drawer.fulfillment.trackingNumbers": "Nomor pelacakan",
    "message.views.workbench.all": "Semua",
    "message.CreateTransferOrder.receiverInfo": "Penerima informasi",
    "message.views.workbench.totalItemSold": "Total barang Terjual",
    "message.views.publishTemplateView.deleteTemplate": "Hapus Templat",
    "message.table.fulfillment.tradeOrderId": "Id pesanan Dagang",
    "message.transform.shopBindingWaitingMention": "Pengikatan toko diharapkan memakan waktu beberapa menit, Jangan tutup halaman saat ini.",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_OUT": "Menyesuaikan diri",
    "message.views.inventoryLedger.orderTypeMap.OTHER": "Lainnya",
    "message.views.publishTemplateView.shortDesc": "Deskripsi singkat",
    "message.aegInboundDetail.purchaseItemColumn.scItemId": "SKU pemenuhan",
    "message.aegOutboundOrderDetail.title.totalQtyDec": "Kuantitas",
    "message.views.workbench.dod": "Rasio harian",
    "message.button.setting": "Pengaturan",
    "message.views.inventoryLedger.orderTypeMap.TRADE_OUT": "Pemenuhan keluar",
    "message.views.publishTemplateView.submit": "Kirim",
    "message.views.scItemView.sureDelete": "Yakin ingin menghapus?",
    "message.card.fulfillment.fulfillmentOrderItemId": "Penggenapan Id barang pesanan",
    "message.lzdOutboundViewDetail.title.userNick": "Pengguna Nick",
    "message.aegOutboundOrderDetail.title.batchInformation": "Kumpulan informasi",
    "message.inboundView.alert.prompt": "Prompt cepat",
    "message.message.fulfillment.batchShippingMessage": "Anda hanya dapat memilih pesanan dari satu pedagang pada satu waktu untuk pengiriman!",
    "message.views.workbench.inboundOrderNo": "Kode pesanan masuk",
    "message.views.liveInventory.shipper": "Pengirim barang",
    "message.lzdInboundDetail.title.sellerName": "Nama penjual",
    "message.form.fulfillment.merchantList": "Pedagang itu",
    "message.table.fulfillment.tradePayTime": "Waktu pembayaran perdagangan",
    "message.lzdInboundCreateView.addSkuView.barcodes": "Barcode",
    "message.views.inventoryLedger.resultQuantity": "Kuantitas hasil",
    "message.lzdInboundDetail.title.skus": "SKU",
    "message.views.workbench.gmv": "GMV",
    "message.menu.fulfillment": "Pemenuhan",
    "message.card.fulfillment.buyerName": "Nama pembeli",
    "message.views.publishTemplateView.gmtModified": "Modifikasi waktu",
    "message.taskCenterView.title.createdTime": "Waktu yang dibuat",
    "message.message.fulfillment.chooseOneOrder": "Pilih setidaknya satu pesanan untuk pengiriman!",
    "message.outboundView.table.outboundOrder": "Pesanan keluar",
    "message.menu.liveInventory": "Inventaris langsung",
    "message.views.workbench.dashboardDescription.totalOrderQuantity": "Semua barang yang dijual: jumlah semua pesanan gudang, rasio Mingguan: (jumlah pesanan minggu ini-jumlah pesanan minggu ini tahun lalu)/jumlah pesanan minggu ini tahun lalu, rasio harian (jumlah pesanan hari ini-jumlah pesanan hari ini tahun lalu) /Jumlah pesanan hari ini tahun lalu, jumlah pesanan hari: jumlah pesanan hari ini",
    "message.lzdInboundCreateView.tableColumn.sellerPostcode": "Kode pos",
    "message.aegInboundDetail.title.orderStatus": "Status pesanan",
    "message.lzdInboundCreateView.tableColumn.deleteBtn": "Hapus",
    "message.aegInboundDetail.logisticColumn.fulfillStatusDesc": "Memenuhi Status Desc",
    "message.table.fulfillment.tradeOrderItemId": "Id barang pesanan Dagang",
    "message.outboundView.table.planQuantity": "Kuantitas rencana",
    "message.inboundView.button.exportBtn": "Ekspor",
    "message.CreateTransferOrder.receiverPostCode": "Penerima kode pos",
    "message.transform.cancel": "Batalkan pesanan",
    "message.views.scItemView.skuStatus": "Status SKU",
    "message.transform.startInventoryBind": "Mulai persediaan ikat",
    "message.views.inventoryAging.averageAge": "Usia rata-rata",
    "message.views.workbench.inbound": "Masuk",
    "message.views.stockAllocation.channelName": "Nama Saluran",
    "message.table.fulfillment.cbOrderStatusDesc": "Status pesanan CB",
    "message.transform.shopBindSuccess": "Ikatan toko berhasil",
    "message.table.fulfillment.shippingTypeDesc": "Jenis pengiriman",
    "message.table.fulfillment.itemTaxActualFee": "Biaya aktual pajak barang",
    "message.outboundView.button.exportSelectedOrder": "Pesanan ekspor pilihan",
    "message.menu.outboundItem": "Outbound",
    "message.views.activityInventory.campaignName": "Nama kampanye",
    "message.views.workbench.warehouse": "Gudang gudang",
    "message.transform.lzd.description": "Pintu masuk penjilid toko Lazada",
    "message.views.inventoryAging.31-60day": "31-60 hari",
    "message.menu.fulfillmentOrder": "Pesanan khusus",
    "message.outboundView.table.outboundReason": "Alasan keluar",
    "message.aegOutboundOrderDetail.title.createTime": "Waktu yang dibuat",
    "message.views.scItemView.upShelf": "Rak atas",
    "message.common.commit": "Berkomitmen",
    "message.lzdInboundDetail.title.sellerAddress": "Alamat penjual",
    "message.card.fulfillment.tradeOrderItemId": "Id barang pesanan Dagang",
    "message.outboundView.table.outboundTime": "Waktu keluar",
    "message.form.fulfillment.shippingTypeDesc": "Jenis pengiriman",
    "message.outboundView.table.createTime": "Waktu yang dibuat",
    "message.views.dashboardScore.dashboardName.all_authorized_shop": "Semua toko resmi",
    "message.views.productPublishView.mainImage": "Gambar utama",
    "message.views.inventoryLedger.orderTypeMap.IMBALANCE_LOCK": "Kunci gudang",
    "message.common.select": "Pilih silakan",
    "message.card.fulfillment.orderInformation": "Informasi pesanan",
    "message.taskCenterView.title.source": "Sumber",
    "message.card.fulfillment.receiverPhone": "Telepon penerima",
    "message.lzdInboundCreateView.tableColumn.inboundType": "Tipe masuk",
    "message.transform.toTransfer": "Untuk mentransfer",
    "message.menu.inventoryLedger": "Persediaan buku besar",
    "message.outboundView.table.skuQuantity": "Kuantitas",
    "message.card.fulfillment.fulfillmentOrderInformation": "Pemenuhan informasi pesanan",
    "message.views.workbench.productSold": "Produk yang dijual",
    "message.views.scItemView.skuId": "SKU ID",
    "message.table.fulfillment.itemShippingActualPaidFee": "Biaya pembayaran aktual pengiriman barang",
    "message.CreateTransferOrder.senderTel": "Pengirim Tel",
    "message.lzdInboundCreateView.tableColumn.deliverType": "Jenis pengiriman",
    "message.lzdOutboundViewDetail.title.deliverTypeName": "Kirimkan Nama tipe",
    "message.outboundView.title.fulfilmentOrderCode": "Pemenuhan pesanan No.",
    "message.views.scItemView.gmtModified": "Modifikasi waktu",
    "message.views.workbench.currentQuantity": "Kuantitas saat ini",
    "message.menu.demoDashboard": "Demo dasbor",
    "message.table.fulfillment.scItemName": "Nama barang Sc",
    "message.CreateTransferOrder.entityCode": "Sumber gudang",
    "message.views.activityInventory.channelCode": "Kode Saluran",
    "message.table.fulfillment.receiverName": "Nama penerima",
    "message.menu.inventory": "Persediaan barang",
    "message.lzdInboundCreateView.title.sellerFlag": "Informasi penjual",
    "message.lzdInboundCreateView.tableColumn.sellerCity": "Kota penjual",
    "message.menu.fulfillmentOrderDetail": "Pemenuhan Detail pesanan",
    "message.lzdInboundCreateView.tableColumn.addBtn": "Tambahkan",
    "message.lzdOutboundViewDetail.title.SKU": "SKU",
    "message.views.inventoryReconciliation.startDateStock": "Stok tanggal mulai",
    "message.lzdInboundCreateView.tableColumn.estimatedTime": "Perkiraan waktu",
    "message.lzdInboundCreateView.title.basicFlag": "Informasi dasar",
    "message.outboundView.table.detail": "Detail produk",
    "message.outboundView.table.merchantName": "Nama pedagang",
    "message.views.workbench.orderQuantityRank": "Peringkat kuantitas pesanan",
    "message.aegOutboundOrderDetail.title.totalReturnQuantity": "Kuantitas pengembalian",
    "message.lzdInboundDetail.title.ioType": "Tipe Io",
    "message.views.productPublishView.submit": "Kirim",
    "message.views.scItemView.productType": "Jenis Produk",
    "message.inboundView.button.importBtn": "Impor",
    "message.views.activityInventory.fulfillmentSkuName": "Nama Sku pemenuhan",
    "message.table.fulfillment.trackingNumbers": "Nomor pelacakan",
    "message.aegInboundDetail.logisticColumns.bizOrderNo": "Nomor aliran",
    "message.taskCenterView.table.taskStatus": "Status tugas",
    "message.aegOutboundOrderDetail.consignColumn.gmtCreateStr": "Waktu yang dibuat",
    "message.views.stockAllocation.allLessThan100": "Semua rasio tidak diperbolehkan kurang dari 100, silakan sesuaikan.",
    "message.views.workbench.thisMonth": "Bulan ini",
    "message.table.fulfillment.warehouseName": "Nama gudang",
    "message.lzdInboundCreateView.addSkuView.shelfLife": "Umur simpan",
    "message.transform.bindException": "Pengecualian penjilidan inventaris",
    "message.inboundView.table.detail": "Detail produk",
    "message.views.productView.mainShop": "Toko utama",
    "message.lzdInboundCreateView.addSkuView.searchBtn": "Pencarian",
    "message.lzdInboundDetail.lzdItemTable.itemRequested": "Item yang diminta",
    "message.lzdInboundCreateView.tableColumn.contactPerson": "Nama kontak",
    "message.views.productView.platformTitle": "Judul",
    "message.views.inventoryLedger.inventoryTypeMap.transferOnWay": "TRANSFER di jalan",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_IN": "Penyesuaian status persediaan",
    "message.views.productView.gmtModified": "Modifikasi waktu",
    "message.login.switch_to_in_id": "Beralih ke bahasa Indonesia",
    "message.views.liveInventory.shopName": "Nama Toko",
    "message.lzdInboundDetail.title.sellerInformation": "Informasi penjual",
    "message.card.fulfillment.promiseLatestDate": "Janji tanggal terbaru",
    "message.transform.bindCheckException": "Pemeriksaan pengikatan inventaris adalah pengecualian",
    "message.views.workbench.yoy": "YOY",
    "message.CreateTransferOrder.senderInfo": "Info pengirim",
    "message.aegOutboundOrderDetail.title.logisticLogs": "Log logistik",
    "message.transform.boundShop": "Toko ikat",
    "message.transform.failDetail": "Silakan lihat rincian tentang kegagalan",
    "message.views.scItemView.operation": "Operasi:",
    "message.card.fulfillment.receiverName": "Nama penerima",
    "message.views.scItemView.fulfillmentTitle": "Judul pendaftaran",
    "message.aegOutboundOrderDetail.title.merchantName": "Nama pedagang",
    "message.taskCenterView.table.gmtCreated": "Waktu yang dibuat",
    "message.inboundView.alert.title": "Anda yakin ingin membatalkan?",
    "message.table.fulfillment.reverseTradeOrderId": "Id pesanan perdagangan mundur",
    "message.views.inventoryLedger.orderTypeMap.REFOUND_IN": "Pemenuhan terbalik masuk",
    "message.aegInboundDetail.title.batchInformation": "Kumpulan informasi",
    "message.views.scItemView.sureBind": "Yakin untuk mengikat?",
    "message.transform.orderCheck": "Cek pesanan ICP/IO",
    "message.lzdOutboundViewDetail.title.basicInformation": "Informasi dasar",
    "message.views.liveInventory.unSellableOccupy": "Dipesan tidak dapat laku",
    "message.login.user_profile": "Profil Pengguna",
    "message.views.inventoryAging.fulfillmentSkuName": "Nama Sku pemenuhan",
    "message.card.fulfillment.receiverProvince": "Provinsi penerima",
    "message.views.scItemView.category": "Kategori",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_IN": "Transfer stok masuk",
    "message.lzdInboundCreateView.addSkuView.addSkuTitle": "Tambah Sku",
    "message.menu.ownerTransfer.title": "OwnerTransfer",
    "message.views.feedback.feedbackOptions.systemBug": "Bug sistem",
    "message.outboundView.title.warehouseList": "Gudang gudang",
    "message.views.inventoryAging.platform": "Hak tebal",
    "message.table.fulfillment.action": "Tindakan",
    "message.transform.selectShop": "Pilih Toko",
    "message.views.productView.category": "Kategori",
    "message.transform.isDone": "Sudah dilakukan",
    "message.outboundView.table.orderQuantity": "Kuantitas",
    "message.views.stockAllocation.platformSkuName": "Nama Sku Platform",
    "message.views.productView.platformSkuDetail": "Detail SKU",
    "message.aegOutboundOrderDetail.title.storeCode": "Kode toko",
    "message.views.productView.scItemMerchant": "Tanda terima pedagang",
    "message.aegInboundDetail.title.channel": "Saluran air",
    "message.inboundView.table.expectedTime": "Waktu yang diharapkan",
    "message.views.stockAllocation.adjustRuleSuccess": "Sesuaikan aturan sukses",
    "message.lzdInboundCreateView.addSkuView.fulfilmentSku": "Sku pemenuhan",
    "message.transform.unfinished": "Belum selesai",
    "message.views.workbench.shopOrderQuantityData": "Proporsi kuantitas pesanan",
    "message.views.dashboardScore.dashboardName.proportion_of_shop_product_sold": "Proporsi produk toko yang dijual",
    "message.table.fulfillment.buyerName": "Nama pembeli",
    "message.views.scItemView.barcode": "Barcode",
    "message.form.fulfillment.tradeOrderId": "Id pesanan Dagang",
    "message.lzdInboundCreateView.addSkuView.platformSku": "Sku Platform",
    "message.aegOutboundOrderDetail.purchaseItemColumn.barcode": "Bare Code",
    "message.aegInboundDetail.logisticColumn.fulfillStatus": "Memenuhi Status",
    "message.outboundView.button.exportBtn": "Ekspor",
    "message.aegOutboundOrderDetail.purchaseItemColumn.scItemId": "Id Item",
    "message.transform.waitingMention": "Penjilidan inventaris diharapkan memakan waktu beberapa menit, Jangan tutup halaman saat ini.",
    "message.inboundView.title.platform": "Hak tebal",
    "message.login.switch_to_en_us": "Switch To English",
    "message.menu.feedback.dashboardScore": "Skor dasbor",
    "message.card.fulfillment.trackingNumber": "Nomor pelacakan",
    "message.menu.dashboard": "Dasbor",
    "message.inboundView.button.template": "Templat pakaian",
    "message.lzdOutboundViewDetail.title.orderStatus": "Status pesanan",
    "message.views.inventoryLedger.orderTypeMap.CHECK_IN": "Gain hitungan siklus",
    "message.aegOutboundOrderDetail.title.inventoryType": "Jenis persediaan",
    "message.CreateTransferOrder.receiverTel": "Penerima Tel",
    "message.views.productView.fulfillmentTitle": "Judul pendaftaran",
    "message.aegOutboundOrderDetail.purchaseItemColumn.remark": "Komentar",
    "message.message.fulfillment.shippingSuccess": "Pengiriman sukses!",
    "message.menu.taskCenterItem": "Pusat Unduh",
    "message.views.activityInventory.scItemId": "ScItemId",
    "message.views.liveInventory.unSellable": "Sulit dijual",
    "message.views.stockAllocation.edit": "Mengedit",
    "message.views.workbench.toReplenishment": "Untuk pengisian",
    "message.menu.inventoryAging": "Persediaan penuaan",
    "message.lzdInboundCreateView.addSkuView.serialNumber": "Nomor seri",
    "message.table.fulfillment.fulfillmentOrderItemId": "Penggenapan Id barang pesanan",
    "message.views.productView.operation": "Operasi:",
    "message.views.inventoryAging.greate180day": "Lebih dari 180 hari",
    "message.taskCenterView.table.operate": "Mengoperasikan",
    "message.card.fulfillment.receiverZip": "Zip penerima",
    "message.button.print": "Cetak cepat",
    "message.aegOutboundOrderDetail.purchaseItemColumn.quantityDec": "Kuantitas",
    "message.views.liveInventory.sellableOccupy": "Dijual sesuai pesanan",
    "message.button.export": "Ekspor",
    "message.table.fulfillment.itemId": "Id Item",
    "message.views.inventoryReconciliation.changeTypeMap.totalSellerInboundedStock": "Batas penjualan",
    "message.views.liveInventory.onWay.inBoundOnWay": "Jalan masuk OnWay",
    "message.lzdOutboundViewDetail.title.ioTypeName": "Tipe Io",
    "message.menu.stockAllocation": "Manajemen persediaan Saluran",
    "message.form.fulfillment.cbFulfillmentOrderId": "Id pesanan pemenuhan Cb",
    "message.aegInboundDetail.btn.detail": "Detail produk",
    "message.views.workbench.ito": "Persediaan menyerahkan",
    "message.views.stockAllocation.adjustStockFailed": "Gagal menyesuaikan persediaan",
    "message.inboundView.button.createInboundBtn": "Buat Io baru",
    "message.transform.downStep": "Langkah berikutnya",
    "message.table.fulfillment.merchantCode": "Pedagang itu",
    "message.CreateTransferOrder.deliverType": "Jenis pengiriman",
    "message.lzdInboundCreateView.addSkuView.queryView.platformSku": "Sku Platform",
    "message.views.scItemView.itemSite": "Situs produk",
    "message.card.fulfillment.fulfillmentOrderId": "Penggenapan Id pesanan",
    "message.aegOutboundOrderDetail.consignColumn.operate": "Mengoperasikan",
    "message.views.dashboardScore.dashboardName.to_deliver": "Untuk mengantarkan",
    "message.inboundView.table.platform": "Hak tebal",
    "message.modal.pdfTitle": "Pdf berhasil dihasilkan",
    "message.views.inventoryLedger.inventoryType": "Jenis persediaan",
    "message.inboundView.table.warehouse": "Gudang gudang",
    "message.views.feedback.systemRate": "Tingkat sistem",
    "message.menu.inboundItemName": "Masuk",
    "message.CreateTransferOrder.senderAddress": "Alamat pengirim",
    "message.views.dashboardScore.dashboardName.channel_product_sold": "Produk kanal dijual",
    "message.login.switch_to_vi_vn": "Chuyển sang tiếng Việt",
    "message.views.scItemView.merchant": "Pedagang itu",
    "message.transform.shopBindFailed": "Pengikatan toko gagal",
    "message.lzdInboundDetail.lzdItemTable.sellerSku": "Sku penjual",
    "message.views.inventoryLedger.orderTypeMap.OTHER_INBOUND": "Pengembalian pelanggan masuk",
    "message.transform.failed": "Gagal",
    "message.views.inventoryReconciliation.endDateStock": "Stok tanggal berakhir",
    "message.views.liveInventory.onWayName": "Dalam perjalanan",
    "message.lzdInboundCreateView.tableColumn.sellerDetail": "Detail penjual",
    "message.menu.createNewInboundOrder": "Buat pesanan masuk baru",
    "message.aegInboundDetail.title.creator": "Pencipta",
    "message.inboundView.table.planQuantity": "Kuantitas rencana",
    "message.lzdInboundCreateView.addSkuView.goodQuantity": "Kuantitas bagus",
    "message.lzdInboundCreateView.tableColumn.sellerCountry": "Negara penjual",
    "message.table.fulfillment.itemQuantity": "Jumlah barang",
    "message.views.stockAllocation.sellableStock": "Stok yang dapat dijual",
    "message.outboundView.title.outboundOrderNo": "No keluar.",
    "message.views.inventoryLedger.orderTypeMap.OUTBOUND": "Penjual/pemasok keluar",
    "message.lzdInboundPlanView.replenishColumns.scItemName": "Nama SKU pemenuhan",
    "message.inboundView.alert.shop": "Belanja pilihan",
    "message.views.scItemView.platformSkuDetail": "Detail PlatformSku",
    "message.login.switch_to_th_th": "เปลี่ยนเป็นภาษาไทย",
    "message.lzdOutboundViewDetail.title.logisticLogs": "Log logistik",
    "message.views.inventoryLedger.orderTypeMap.B2B_PURCHASE_IN": "Pengiriman gagal masuk",
    "message.views.stockAllocation.ruleAllocation": "Menyesuaikan aturan",
    "message.button.cancel": "Batalkan pesanan",
    "message.outboundView.table.cancel": "Batalkan pesanan",
    "message.views.inventoryAging.61-90day": "61-90 hari",
    "message.outboundView.button.reset": "Atur ulang",
    "message.views.feedback.feedbackOptions.productSuggestion": "Saran produk",
    "message.taskCenterView.title.taskStatus": "TaskStatus",
    "message.views.productView.fulfillmentSku": "FulfillmentSku",
    "message.lzdInboundCreateView.title.skuFlag": "SKU",
    "message.lzdOutboundViewDetail.title.outboundOrderCode": "No keluar",
    "message.lzdInboundCreateView.addSkuView.queryView.fulfilmentSku": "Sku pemenuhan",
    "message.views.dashboardScore.table.rate": "Tingkat",
    "message.views.publishTemplateView.longDesc": "Deskripsi panjang",
    "message.transform.firstStep": "Langkah pertama",
    "message.inboundView.table.supplier": "Pemasok",
    "message.login.switch_to_zh_cn": "切换为中文",
    "message.views.scItemView.basicInfo": "Info dasar",
    "message.views.inventoryLedger.inventoryTypeMap.defective": "CACAT",
    "message.views.workbench.shopGmvProportion": "Proporsi GMV",
    "message.views.workbench.orderQuantityTendency": "Kecenderungan kuantitas pesanan",
    "message.common.detail": "Detail produk",
    "message.views.productView.showRelation": "Menunjukkan hubungan",
    "message.views.inventoryAging.inventoryType": "Jenis persediaan",
    "message.inboundView.button.exportSelectedOrder": "Pesanan ekspor pilihan",
    "message.views.publishTemplateView.templateName": "TemplateName",
    "message.views.liveInventory.commodity": "Komoditas",
    "message.views.workbench.dashboardDescription.channelProductSold": "Bagan batang produk yang dijual dari berbagai saluran dalam minggu lalu",
    "message.transform.stockBindStore": "Toko serba ada stok",
    "message.views.dashboardScore.dashboardName.all_order_quantity": "Jumlah Total pesanan",
    "message.aegInboundDetail.logisticColumn.operateTime": "Mengoperasikan waktu",
    "message.inboundView.table.expiredTime": "Waktu kedaluwarsa",
    "message.transform.startCheck": "Mulai cek penjilidan inventaris",
    "message.views.scItemView.platformSku": "PlatformSku",
    "message.views.dashboardScore.table.operation": "Operasi:",
    "message.views.activityInventory.fulfillmentSkuCode": "Kode Sku pemenuhan",
    "message.views.workbench.shopName": "Nama Toko",
    "message.transform.shipperCheck": "Cek pengirim",
    "message.transform.success": "Sukses besar",
    "message.aegInboundDetail.logisticColumns.fulfillStatus": "Status barang",
    "message.transform.bindFailed": "Pengikatan persediaan gagal",
    "message.button.orderExport": "Pesanan ekspor",
    "message.views.dashboardScore.dashboardName.monthly_product_sold_and_item_ranking": "Produk dijual bulanan dan peringkat Item",
    "message.transform.auth": "Otorisasi",
    "message.menu.gfc.enter": "Masukkan GFC",
    "message.views.scItemView.downShelf": "Rak bawah",
    "message.inboundView.table.merchantName": "Nama pedagang",
    "message.button.helpCenter": "Pusat Bantuan",
    "message.aegInboundDetail.goodsTable.defectiveQtyDec": "Kuantitas yang rusak.",
    "message.lzdInboundDetail.title.shop": "Toko",
    "message.views.inventoryLedger.orderTypeMap.COORDINATE_OUT": "Pemindahan stok keluar",
    "message.views.inventoryReconciliation.changeTypeMap.totalLost": "Hilang",
    "message.views.productPublishView.clickDownloadPublishTemplate": "Unduh templat publikasi",
    "message.views.productPublishView.upload": "Unggah",
    "message.views.inventoryLedger.operateTime": "Waktu operasi",
    "message.menu.publishTemplateView": "Templat pakaian",
    "message.views.stockAllocation.fulfillmentSkuName": "Nama Sku pemenuhan",
    "message.card.fulfillment.tradeCreateTime": "Perdagangan membuat waktu",
    "message.views.scItemView.fileExport": "Ekspor",
    "message.views.inventoryLedger.orderTypeMap.CHECK_OUT": "Siklus hitung kerugian",
    "message.inboundView.button.search": "Pencarian",
    "message.views.inventoryLedger.orderTypeMap.INVENTORY_STATUS_ADJUST_OUT": "Penyesuaian status persediaan",
    "message.views.activityInventory.site": "Situs Web",
    "message.inboundView.alert.cancel": "Batalkan pesanan",
    "message.button.search": "Pencarian",
    "message.views.stockAllocation.totalInventory": "Total persediaan",
    "message.table.fulfillment.orderItemStatus": "Kode Status barang pesanan",
    "message.views.stockAllocation.ratio": "Rasio rasio",
    "message.views.scItemView.height": "Tinggi badan",
    "message.aegInboundDetail.purchaseItemColumn.title": "SKU penjual",
    "message.menu.scItemView": "Barang Barang",
    "message.aegInboundDetail.purchaseItemColumn.measureUnit": "Unit pengukur",
    "message.CreateTransferOrder.senderPostCode": "Pengirim kode pos",
    "message.card.fulfillment.receiverMobile": "Ponsel penerima",
    "message.inboundView.button.createOutboundBtn": "Buat Oo baru",
    "message.outboundView.title.returnReason": "Alasan pengembalian",
    "message.views.scItemView.status": "Status barang",
    "message.inboundView.button.exportAllOrder": "Ekspor semua pesanan",
    "message.inboundView.table.createTime": "Waktu yang dibuat",
    "message.transform.transferred": "Ditransfer",
    "message.card.fulfillment.tradePayTime": "Waktu pembayaran perdagangan",
    "message.views.scItemView.shelfLifeManagement": "Manajemen kehidupan rak",
    "message.views.inventoryLedger.inventoryTypeMap.onWay": "Dalam perjalanan",
    "message.aegOutboundOrderDetail.title.remark": "Komentar",
    "message.views.scItemView.mainShop": "Toko utama",
    "message.login.switch_to_another_language": "切换为中文",
    "message.views.productPublishView.publishShop": "Publikasikan toko",
    "message.views.scItemView.itemId": "ProductID",
    "message.table.fulfillment.itemActualPaidFee": "Biaya dibayar aktual Item",
    "message.transform.recentBindInventoryRecord": "Hasil penjilidan persediaan terbaru",
    "message.lzdInboundCreateView.addSkuView.scItemName": "Nama barang",
    "message.lzdInboundCreateView.tableColumn.warehouse": "Gudang gudang",
    "message.views.productView.price": "Harga",
    "message.table.fulfillment.buyerId": "Id pembeli",
    "message.inboundView.table.operate": "Mengoperasikan",
    "message.transform.startShopBindCheck": "Mulai cek pengikatan toko",
    "message.views.activityInventory.search": "Pencarian",
    "message.lzdInboundCreateView.addSkuView.quantity": "Kuantitas yang diminta",
    "message.transform.finished": "Selesai",
    "message.inboundView.table.creator": "Pencipta",
    "message.form.fulfillment.inputShippingName": "Masukkan nama pengiriman!",
    "message.views.workbench.dailyOrderQuantity": "Jumlah pesanan harian",
    "message.views.productPublishView.skuImage": "Sku gambar",
    "message.views.productView.skuStatus": "Status SKU",
    "message.CreateTransferOrder.receiverCountry": "Negara penerima",
    "message.aegOutboundOrderDetail.consignColumn.supplierName": "Nama pemasok",
    "message.views.scItemView.length": "Panjang",
    "message.views.workbench.thisWeek": "Minggu ini",
    "message.views.workbench.totalGmv": "Total Gmv",
    "message.inboundView.title.createTime": "Waktu yang dibuat",
    "message.aegInboundDetail.title.storeCode": "Kode toko",
    "message.views.inventoryLedger.changeQuantity": "Ubah kuantitas",
    "message.aegOutboundOrderDetail.consignColumn.reserveOrderNo": "Cadangan No.",
    "message.table.fulfillment.cod": "Cod",
    "message.views.inventoryLedger.orderCode": "Kode pesanan",
    "message.views.workbench.fulfillmentOrderId": "Penggenapan Id pesanan",
    "message.table.fulfillment.unitPrice": "Harga satuan",
    "message.lzdOutboundViewDetail.title.mobile": "Ponsel seluler",
    "message.table.fulfillment.sellerId": "Id penjual",
    "message.drawer.fulfillment.shippingType": "Jenis pengiriman",
    "message.lzdInboundDetail.title.inboundOrderCode": "Nomor Pesanan masuk",
    "message.views.workbench.fulfillmentOrderItemId": "Penggenapan Id barang pesanan",
    "message.taskCenterView.table.taskId": "Id tugas",
    "message.outboundView.table.supplier": "Pemasok",
    "message.outboundView.table.orderStatus": "Status pesanan",
    "message.views.activityInventory.expireTime": "Waktu kedaluwarsa",
    "message.table.fulfillment.warehouseCode": "Kode gudang",
    "message.views.liveInventory.cargo": "Kargo kargo",
    "message.aegInboundDetail.purchaseItemColumn.receivedDefectiveQtyDec": "Diterima dalam jumlah yang rusak",
    "message.views.stockAllocation.stockAllocation": "Sesuaikan persediaan",
    "message.aegInboundDetail.title.remart": "Remart toko",
    "message.aegOutboundOrderDetail.consignColumn.formatPreArriveTime": "Waktu pra tiba",
    "message.views.liveInventory.warehouse": "Gudang gudang",
    "message.lzdOutboundViewDetail.title.estimateTimeStr": "Perkiraan waktu",
    "message.aegInboundDetail.title.expectedTime": "Waktu yang diharapkan",
    "message.table.fulfillment.receiverMobile": "Ponsel penerima",
    "message.card.fulfillment.deliveryInfomation": "Informasi pengiriman",
    "message.views.inventoryLedger.orderTypeMap.ADJUST_IN": "Menyesuaikan dalam",
    "message.table.fulfillment.totalFee": "Biaya Total",
    "message.login.log_out": "Keluar dari sini",
    "message.views.productView.barcode": "Barcode",
    "message.transform.operateStore": "Toko beroperasi",
    "message.aegInboundDetail.title.purchaseOrderCode": "Kode pesanan pembelian",
    "message.views.inventoryReconciliation.changeTypeMap.totalShipped": "Dikirim ke pelanggan",
    "message.transform.authList": "Daftar otorisasi",
    "message.views.stockAllocation.adjustStockSuccess": "Sesuaikan keberhasilan stok",
    "message.inboundView.title.fulfilmentOrderCode": "Pemenuhan pesanan No.",
    "message.views.workbench.deliver": "Pengiriman cepat",
    "message.views.scItemView.weight": "Berat badan",
    "message.table.fulfillment.cbFulfillmentOrderItemId": "Id barang pesanan pemenuhan CB",
    "message.aegInboundDetail.title.cancelPerson": "Batalkan orang",
    "message.views.workbench.channelSales": "Saluran Gmv",
    "message.table.fulfillment.itemName": "Nama barang",
    "message.card.fulfillment.shipperId": "Id pemilik pesanan",
    "message.views.publishTemplateView.merchant": "Pedagang itu",
    "message.drawer.fulfillment.ship": "Kapal selam",
    "message.views.inventoryReconciliation.ledgerDetail": "Detail buku besar",
    "message.lzdInboundDetail.lzdItemTable.scItemName": "Nama barang",
    "message.aegInboundDetail.logisticColumn.operator": "Operator",
    "message.button.reset": "Atur ulang",
    "message.transform.errorFile": "Kesalahan berkas",
    "message.menu.createNewOutboundOrder": "Buat pesanan keluar baru",
    "message.menu.feedback.feedback": "Umpan balik",
    "message.views.publishTemplateView.gmtCreate": "Membuat waktu",
    "message.aegInboundDetail.goodsTable.normalQtyDec": "Kuantitas Normal.",
    "message.aegOutboundOrderDetail.title.skuVariety": "Sku",
    "message.table.fulfillment.sellerSku": "Sku penjual",
    "message.lzdOutboundViewDetail.title.address": "Alamat",
    "message.menu.fulfillmentPackageDetail": "Detail paket pemenuhan",
    "message.aegInboundDetail.goodsTable.scItemId": "SKU pemenuhan",
    "message.lzdInboundDetail.title.basicInformation": "Informasi dasar",
    "message.views.liveInventory.code": "Kode",
    "message.views.workbench.dailyGmv": "Gmv harian",
    "message.transform.shopBind": "Ikatan toko",
    "message.aegInboundDetail.logisticColumns.operateTime": "Waktu operasi",
    "message.views.workbench.allShop": "Semua toko",
    "message.CreateTransferOrder.senderName": "Nama pengirim",
    "message.outboundView.title.createTime": "Waktu yang dibuat",
    "message.select.fulfillment.completeShipping": "Kirim semua",
    "message.card.fulfillment.tradeOrderId": "Id pesanan Dagang",
    "message.views.inventoryLedger.orderTypeMap.PURCHASE_IN": "Penjual/pemasok masuk",
    "message.card.fulfillment.orderStatus": "Status pesanan",
    "message.inboundView.button.AegTemplate": "Ae Global",
    "message.views.inventoryReconciliation.changeTypeMap.totalOtherOutbounded": "Lainnya melampaui",
    "message.transform.downloadErrorFileUrl": "Tautan unduhan File yang salah",
    "message.transform.itemCheck": "PlatformSku/ikutmentsku cek",
    "message.transform.mentionInfo": "Penjilidan inventaris diperkirakan akan memakan waktu beberapa menit. Jangan tutup halaman saat ini",
    "message.lzdInboundDetail.title.purchaseOrderCode": "Pembelian nomor pesanan",
    "message.card.fulfillment.shippingProviderName": "Nama penyedia pengiriman",
    "message.inboundView.button.reset": "Atur ulang",
    "message.table.fulfillment.receiverZip": "Zip penerima",
    "message.aegInboundDetail.logisticColumns.fulfillStatusDesc": "Deskripsi Status",
    "message.lzdInboundPlanView.queryForm.scItemCode": "SKU pemenuhan",
    "message.views.scItemView.deleteRelatedPlatformSku": "Hapus item terkait",
    "message.lzdInboundDetail.lzdItemTable.scItemId": "Id Item",
    "message.menu.inventoryReconciliation": "Rekonsiliasi persediaan",
    "message.drawer.fulfillment.shippingName": "Nama pengiriman",
    "message.aegOutboundOrderDetail.consignColumn.inboundNo": "Logistik No.",
    "message.aegInboundDetail.title.cancelTime": "Waktu pembatalan",
    "message.form.fulfillment.fulfillmentOrderId": "Penggenapan Id pesanan",
    "message.transform.startTime": "Waktu mulai",
    "message.views.workbench.thisQuarter": "Kuartal ini",
    "message.card.fulfillment.promiseEarliestDate": "Janji tanggal paling awal",
    "message.views.dashboardScore.dashboardName.all_product_sold": "Total produk Terjual",
    "message.views.inventoryAging.121-150day": "121-150 hari",
    "message.lzdInboundDetail.title.orderStatus": "Status barang",
    "message.card.fulfillment.warehouseCode": "Kode gudang",
    "message.outboundView.button.AegTemplate": "Templat Ae",
    "message.views.liveInventory.name": "Nama produk",
    "message.transform.inventoryBind": "Pengikat inventaris",
    "message.views.dashboardScore.dashboardName.to_supplement": "Untuk melengkapi",
    "message.transform.inventoryCheck": "Pemeriksaan persediaan",
    "message.common.search": "Pencarian",
    "message.outboundView.table.platform": "Hak tebal",
    "message.transform.shopBindFailedAndDownload": "Pengikatan toko gagal, detail kegagalan unduhan",
    "message.inboundView.table.receivedQuantity": "Jumlah yang diterima",
    "message.modal.pdfContext": "Buka cetak atau Unduh",
    "message.views.workbench.cargo": "Kargo kargo",
    "message.views.scItemView.updateScItemButton": "Perbarui kirim",
    "message.views.scItemView.serialNumberManagement": "Manajemen nomor seri",
    "message.views.activityInventory.platformSkuCode": "Kode Sku Platform",
    "message.views.liveInventory.warehouseCode": "Kode gudang",
    "message.form.fulfillment.tradeCreateTime": "Membuat waktu",
    "message.table.fulfillment.tradeCreateTime": "Perdagangan membuat waktu",
    "message.CreateTransferOrder.estimatedOutboundTime": "Perkiraan waktu keluar",
    "message.drawer.fulfillment.deliveryFailed": "Pengiriman gagal",
    "message.views.workbench.noReplenishment": "Tidak ada rencana pengisian",
    "message.views.workbench.toInbound": "Untuk masuk",
    "message.aegOutboundOrderDetail.title.returnOrderNO": "No. Pesanan Retur",
    "message.table.fulfillment.itemDiscountFee": "Biaya diskon Item",
    "message.lzdOutboundViewDetail.title.sellerName": "Nama penjual",
    "message.transform.selectStoresToBindInventory": "Pilih toko untuk mengikat inventaris",
    "message.lzdInboundDetail.title.warehouseName": "Gudang gudang",
    "message.views.stockAllocation.search": "Pencarian",
    "message.inboundView.table.cancel": "Batalkan pesanan",
    "message.form.fulfillment.warehouseCode": "Kode gudang",
    "message.views.inventoryLedger.orderType": "Jenis pesanan",
    "message.views.liveInventory.occupy": "Kunci gembok",
    "message.menu.activityInventory": "Persediaan aktivitas",
    "message.views.scItemView.temperatureCondition": "Kondisi suhu",
    "message.outboundView.button.search": "Pencarian",
    "message.inboundView.title.inboundOrder": "Nomor Pesanan masuk",
    "message.message.fulfillment.deliveryConfirm": "Pengiriman dikonfirmasi!",
    "message.aegInboundDetail.goodsTable.title": "SKU penjual",
    "message.views.productView.platformSku": "PlatformSku",
    "message.menu.authorization.title": "Otorisasi",
    "message.table.fulfillment.receiverPhone": "Telepon penerima",
    "message.views.productPublishView.publishTemplate": "Menerbitkan Template",
    "message.views.productPublishView.plsChooseTemplateToPublish": "Anda dapat memilih templat untuk menerbitkan",
    "message.views.dashboardScore.dashboardName.inventory_turn_over": "Persediaan menyerahkan",
    "message.outboundView.button.importBtn": "Impor",
    "message.button.save": "Hemat",
    "message.inboundView.table.skuQuantity": "Kuantitas",
    "message.aegOutboundOrderDetail.title.orderStatus": "Status pesanan",
    "message.views.publishTemplateView.search": "Pencarian",
    "message.aegInboundDetail.title.logisticLogs": "Log logistik",
    "message.table.fulfillment.receiverCity": "Penerima Kota",
    "message.aegOutboundOrderDetail.purchaseItemColumn.brandName": "Nama merek",
    "message.aegOutboundOrderDetail.title.storeName": "Nama Toko",
    "message.views.workbench.totalProductSold": "Total produk Terjual",
    "message.aegOutboundOrderDetail.logisticColumns.operateTime": "Mengoperasikan waktu",
    "message.views.liveInventory.platform": "Hak tebal",
    "message.views.liveInventory.onWay.transferOnWay": "Transfer OnWay",
    "message.form.fulfillment.deliveryType": "Konfirmasi pengiriman",
    "message.aegOutboundOrderDetail.consignColumn.gmtConfirmReceiveStr": "Konfirmasi waktu yang diterima",
    "message.views.scItemView.itemCode": "Kode Barang",
    "message.views.productView.itemId": "ID Item",
    "message.views.scItemView.bindRelatedPlatformSku": "Ikat item terkait",
    "message.aegOutboundOrderDetail.logisticColumns.bizOrderNo": "Nomor Pesanan Biz",
    "message.inboundView.table.inboundOrder": "Nomor masuk.",
    "message.views.productPublishView.templateDetail": "Templat Detail",
    "message.aegInboundDetail.goodsTable.quantityDec": "Jumlah pembelian",
    "message.views.stockAllocation.warehouse": "Gudang gudang",
    "message.table.fulfillment.cbOrderStatus": "Kode Status pesanan CB",
    "message.menu.item": "Produk/barang",
    "message.views.stockAllocation.channelLock": "Pengunci Saluran",
    "message.select.fulfillment.deliverySuccess": "Pengiriman berhasil",
    "message.views.productPublishView.atLeastOneImage": "Setidaknya satu gambar diperlukan",
    "message.views.inventoryAging.91-120day": "91-120 hari",
    "message.views.workbench.channelOrderQuantity": "Kuantitas pesanan Saluran",
    "message.button.submit": "Kirim",
    "message.menu.inboundPlanItemDetail": "Rincian rencana pengisian",
    "message.views.workbench.quantity": "Kuantitas",
    "message.menu.productView": "Produk produk",
    "message.table.fulfillment.orderItemStatusReason": "Alasan Status barang pesanan",
    "message.views.feedback.feedbackOptions.questionFeedback": "Pertanyaan umpan balik",
    "message.table.fulfillment.actualPaidFee": "Biaya dibayar aktual",
    "message.table.fulfillment.orderStatus": "Kode Status pesanan",
    "message.login.language": "Bahasa Inggris",
    "message.menu.gfc.title": "Masukkan GFC",
    "message.outboundView.table.warehouse": "Gudang gudang",
    "message.table.fulfillment.cbFulfillmentOrderId": "Id pesanan pemenuhan CB",
    "message.aegInboundDetail.title.warehouseAddress": "Alamat",
    "message.common.input": "Masukkan silakan",
    "message.views.dashboardScore.table.comment": "Komentar",
    "message.views.workbench.shopItemSoldData": "Proporsi barang yang dijual",
    "message.taskCenterView.table.errorMsg": "Pesan kesalahan",
    "message.outboundView.button.LzdTemplate": "Templat Lazada",
    "message.card.fulfillment.shippingServiceCode": "Kode layanan pengiriman",
    "message.lzdOutboundViewDetail.title.orderStatusName": "Status barang",
    "message.views.workbench.dailyItemSold": "Barang harian dijual",
    "message.views.productView.itemSite": "Situs Web",
    "message.lzdInboundCreateView.addSkuView.operate": "Mengoperasikan",
    "message.lzdInboundDetail.title.deliverType": "Jenis pengiriman",
    "message.transform.bindSuccess": "Pengikatan persediaan berhasil",
    "message.views.productPublishView.pleaseSelectTheCategory": "Pilih kategori Ya",
    "message.menu.feedback.feedbackName": "Umpan balik",
    "message.table.fulfillment.sellerName": "Nama penjual",
    "message.transform.bindCheckFailed": "Pemeriksaan pengikatan inventaris gagal",
    "message.aegInboundDetail.title.createTime": "Waktu yang dibuat",
    "message.aegOutboundOrderDetail.consignColumn.creator": "Pencipta",
    "message.views.workbench.mom": "Ibu Ibu",
    "message.lzdOutboundViewDetail.title.sellerInformation": "Informasi penjual"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alife_mcms_crossborder-merchant-web_front_end@0.0.20@@alife/mcms_crossborder-merchant-web_front_end/in-id.js
// module id = ZqI1
// module chunks = 16